import config from "./config";
import apiService from "./apiService";
export default {
  async getLoanExcelFile(data) {
    let loanExcelFileDownLoadApiUrl = `${config.loanExcelFileDownLoadApiUrl}`;
    return apiService.post(loanExcelFileDownLoadApiUrl, data, {
      responseType: "blob",
    });
  },
  async preparePDFFile(data) {
    let loanExcelFileDownLoadApiUrl = `${config.loanPDFFileGenerateApiUrl}`;
    return apiService.post(loanExcelFileDownLoadApiUrl, data);
  },
  downloadPDFFile(fileName, token) {
    let loanExcelFileDownLoadApiUrl = `${config.loanPDFFileDownLoadApiUrl}`;
    return `${loanExcelFileDownLoadApiUrl}${fileName}&access_token=${token}`;
  },
};
